import React from 'react';
import { CalendarEvent, useEventsAdminList } from './useEventsAdminList';
import { useHistory } from 'react-router-dom';
import { FormControlsForFields, useFields } from '../../../toolympus/components/schemed';
import { FormGrid, SimpleDialog, SimpleList } from '../../../toolympus/components/primitives';
import { Button, Typography } from '@mui/material';
import { SimplePowerDocViewer } from '../../../toolympus/components/PowerDoc/SimplePowerDocViewer';
import { CreateEventDialog } from './CreateEventDialog';
import { TimeDisplay } from '../../../toolympus/components/schemed/TimeDisplay';
import { ActionTriggerEditButton } from '../../../toolympus/components/Actions';
import { PaymentSettingsPopupButton } from './PaymentSettingsEditor';

interface Props {
  
}

export const CalendarAdminPage = (props: Props) => {
  const data = useEventsAdminList();
  const history = useHistory();

  const fields = useFields({
    defaultFields: [
      "title",
      "start_datetime",
      "registration_status",
      "price_option",
      "created_at",
    ],
    blacklist: [
      "description",
      "description_ru",
      "search_highlights",
    ],
    schema: data.schema,
    storageKey: "_riac_eventadm_fields",
    extraSettings: {
      description_short: { tableControl: SimplePowerDocViewer },
      created_at: { utcToLocal: true, formatAsDate: true },
      updated_at: { utcToLocal: true, formatAsDate: true },
      published_at: { utcToLocal: true, formatAsDate: true },
      actualized_at: { utcToLocal: true, formatAsDate: true },
    }
  });

  return (<>
    <SimpleList
      data={{
        ...data,
        filter: data.filter.filter,
        setFilter: data.filter.setFilter,
        create: () => { data.newRecord.startEditing(); return Promise.resolve({ _id: -1 } as CalendarEvent); }
      }}
      fields={[
      ]}
      fieldElement={f => {
        switch(f) {
          case "end_datetime":
            return r => <TimeDisplay field="end_datetime" row={r} schema={{}} config={{ format: "HH:mm"}} />
        }
      }}
      tabs={[
        ["Published", "published"],
        ["All", "all"],
      ]}
      schema={data.schema}
      getLinkValue={cr => `/events/${cr._id}`}
      linkFields={[ "_id", "title" ]}
      title="Events"
      searchAuto
      searchAutoFocus
      fieldSetings={fields}
      fieldFilters={data.filtering}
      sorting={data.sorting}
      tableProps={{
        tailAnchor: data.limitTrigger.pagingAnchor,
      }}
      headerActions={<>
        <Typography variant="caption" color="textSecondary">Events: {data.count.data.total_records}</Typography>

      </>}
      headerViewActions={<>
        {/* <ButtonOptionPicker
          options={[
            ["мои", "me"],
            ["все", "all"],
          ]}
          selected={data.assignedFilter.value}
          setSelected={data.assignedFilter.update}
          /> */}
      </>}
      headerTailActions={<>
        {/* <PluggableDocumentationButton documentationKey="documents" /> */}
        <Button size="small" onClick={() => data.archiveEvents.startEditing({ year: new Date().getFullYear().toString()})}>
          archive
        </Button>
        <PaymentSettingsPopupButton />
        <ActionTriggerEditButton
          apiPath="/api/actions/trigger"
          triggers={[
            "riac.attendees.event-registration-entities/register",
            "riac.attendees.event-registration-entities/cancel",
            "riac.attendees.event-registration-entities/approve",
            "riac.attendees.event-registration-entities/reject",
            "riac.attendees.event-registration-entities/paid-register",
            "riac.attendees.event-registration-entities/payment",
          ]}
          />
      </>}
      />

    <CreateEventDialog
      {...data.newRecord}
      save={() => data.newRecord.save().then(cr => { history.push(`/events/${cr._id}`); return cr; })}
      schema={data.schema}
      />

    <SimpleDialog
      dialogTitle="Archive events"
      save={() => data.archiveEvents.save()}
      saveLabel="archive"
      noFullscreen
      {...data.archiveEvents.dialog}>
      <FormGrid noMargin columns="1fr">
        <Typography>
          This will archive all events. To complete the action enter the archive year below and press "archive".
        </Typography>

        <FormControlsForFields
          data={data.archiveEvents.item}
          onChange={(o,c) => data.archiveEvents.update(c)}
          schema={{ year: { label: "Year", hint: "this is basically an archive tag - can be anything - just be consistent" }}}
          fields={[
            ["year"]
          ]}
          />
      </FormGrid>
      </SimpleDialog>
  </>);
}
